import { GenericObject } from "utility/misc";

import boxConfig from "./config";

// -----------------------------------------------------------------------------

export default function redirectToBoxOauthUrl(
  orgStore: GenericObject,
  navigate: Function
): void {
  const params = new URLSearchParams({
    client_id: boxConfig.clientID,
    redirect_uri: encodeURI(
      `${window.location.origin}/environment/sources/box/oauth2`
    ),
    state: orgStore.uuid,
    response_type: "code",
  } as any).toString();
  const oauthURL: string = `https://account.box.com/api/oauth2/authorize?${params}`;

  //
  // nosemgrep: javascript.browser.security.open-redirect.js-open-redirect
  window.location.href = oauthURL;
}
